import { DatePicker, DatePickerProps, } from "@basic-components";
import dayjs from "dayjs";
import { FC } from "react";


interface YearPickerProps extends Omit<DatePickerProps, 'value'|'onChange'> {
    value?: number;
    valueType?: 'string' | 'long';
    onChange?: (range: number | null) => void;
    isView?: boolean;
}
export const YearPicker: FC<YearPickerProps> = ({value, format='YYYY', onChange, isView, valueType='long', ...props}) => {
    const formattedValue = value ? dayjs(value + '', format as string) : null;
    const handleChange = (dates: any) => {
        const date: number | null = dates ? Number(dates.format(format)) : null;
        onChange?.(date);
    };

    if (isView) return value || '--';
    return (
        <DatePicker
         {...props}
         picker="year"
         value={formattedValue}
          onChange={handleChange} />
    );
};